import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { media } from '@atlaskit/adf-schema';
import { fg } from '@atlaskit/platform-feature-flags';
import { getMediaAttrs } from './toDOMAttrs';
var skeletonStyling = "background: ".concat("var(--ds-background-neutral, #091E420F)", "; outline: none;");

/**
 * Duplicate consts from `media-card`.
 * `packages/media/media-card/src/utils/cardDimensions.ts`
 *
 * WHY?
 * This will eventually move to `@atlaskit/adf-schema` and we cannot reference
 * `media-card` from here or it will cause dependency issues.
 *
 * In the long term likely `toDOM` will move back out of `adf-schema` in which
 * case we can consolidate them.
 */
export var defaultImageCardDimensions = {
  width: 156,
  height: 125
};

// @nodeSpecException:toDOM patch
export var mediaSpecWithFixedToDOM = function mediaSpecWithFixedToDOM() {
  if (!fg('platform_editor_lazy-node-views')) {
    return media;
  }
  return _objectSpread(_objectSpread({}, media), {}, {
    toDOM: function toDOM(node) {
      var attrs = getMediaAttrs('media', node);
      var styles = skeletonStyling;
      if (node.attrs.type === 'external') {
        return ['img', _objectSpread(_objectSpread({}, attrs), {}, {
          src: node.attrs.url,
          styles: styles
        })];
      }
      if (node.attrs.type === 'file') {
        var dataUrl = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
        var width = defaultImageCardDimensions.width;
        var height = defaultImageCardDimensions.height;
        return ['div', _objectSpread(_objectSpread({
          width: width,
          height: height
        }, attrs), {}, {
          // Manually kept in sync with the style of media cards. The goal is to render a plain gray
          // rectangle that provides an affordance for media.
          style: "\n\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t\tbackground-image: url(\"".concat(dataUrl, "\");\n\t\t\t\t\t\tmargin-left: 0;\n\t\t\t\t\t\tmargin-right: 4px;\n\t\t\t\t\t\tborder-radius: ").concat(skeletonStyling, ";\n\n\t\t\t\t\t\tflex-basis: ").concat(defaultImageCardDimensions.width, "px;\n\t\t\t\t\t\tbackground-color: var(--media-card-background-color, unset);\n\t\t\t\t\t\twidth: var(--media-card-width, 0);\n\t\t\t\t\t\theight: var(--media-card-height, 0);\n\t\t\t\t\t\t")
        })];
      }
      return ['div', _objectSpread(_objectSpread({}, attrs), {}, {
        styles: styles
      })];
    }
  });
};